import Component_Gizmo_22b3ea2e4b25d7c5e2b611854bc10ea4 from "../../../../content/examples/basic/gizmo/Gizmo";
import Devtool_Gizmo_22b3ea2e4b25d7c5e2b611854bc10ea4 from "!!@devtool/loader!../../../../content/examples/basic/gizmo/Gizmo";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Gizmo_22b3ea2e4b25d7c5e2b611854bc10ea4,
  Devtool_Gizmo_22b3ea2e4b25d7c5e2b611854bc10ea4,
  DevTool,
  React
};